var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "help" } }, [
      _c("div", { staticClass: "title" }, [_vm._v("关于我们")]),
      _c("div", { staticClass: "faq-page" }, [
        _c("h2", [_vm._v("KJcs2开箱网")]),
        _c("p", [_vm._v("由亚洲顶级IT技术团队精心打造，立足中国放眼世界。")]),
        _c("p", [
          _vm._v(
            "提供优质的购物环境和公平的开箱体验，所得到的饰品可以通过库存取回到自己的steam游戏账户，"
          ),
        ]),
        _c("p", [
          _vm._v(
            "目前可使用Alipay、Wechat等支付方式，我们秉持诚信可靠的商业理念，提供优质的服务，让广大游戏爱好者获得最好的开箱体验。"
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }